import { render, staticRenderFns } from "./COM_Menu.vue?vue&type=template&id=10d3ad86&scoped=true&"
import script from "./COM_Menu.vue?vue&type=script&lang=js&"
export * from "./COM_Menu.vue?vue&type=script&lang=js&"
import style0 from "./COM_Menu.vue?vue&type=style&index=0&id=10d3ad86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d3ad86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10d3ad86')) {
      api.createRecord('10d3ad86', component.options)
    } else {
      api.reload('10d3ad86', component.options)
    }
    module.hot.accept("./COM_Menu.vue?vue&type=template&id=10d3ad86&scoped=true&", function () {
      api.rerender('10d3ad86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/components/COM_Menu.vue"
export default component.exports